<template>
  <div class="dt-articles-page">
    <!-- 面包屑导航 -->
    <nav class="breadcrumb-nav">
      <router-link to="/">首页</router-link>
      <span class="separator">/</span>
      <router-link to="/consulting/digital-transformation">数字化转型咨询</router-link>
      <span class="separator">/</span>
      <span class="current">专题文章</span>
    </nav>

    <div class="container">
      <!-- 页面标题 -->
      <div class="page-header">
        <h1 class="page-title">数字化转型专题文章</h1>
        <p class="page-desc">精选全球顶级咨询机构与企业实践深度研究，涵盖内涵路径、行业方案、战略规划、首席数据官等核心内容。</p>
      </div>

      <!-- 筛选栏 -->
      <div class="filter-bar">
        <div class="filter-tabs">
          <span class="filter-tab" :class="{ active: activeCategory === 'all' }" @click="activeCategory = 'all'">全部</span>
          <span class="filter-tab" :class="{ active: activeCategory === 'strategy' }" @click="activeCategory = 'strategy'">战略框架</span>
          <span class="filter-tab" :class="{ active: activeCategory === 'industry' }" @click="activeCategory = 'industry'">行业方案</span>
          <span class="filter-tab" :class="{ active: activeCategory === 'itplan' }" @click="activeCategory = 'itplan'">IT规划</span>
          <span class="filter-tab" :class="{ active: activeCategory === 'cdo' }" @click="activeCategory = 'cdo'">首席数据官</span>
        </div>
        <div class="search-box">
          <input type="text" class="search-input" placeholder="搜索文章..." v-model="searchKeyword" @keyup.enter="searchArticles">
          <button class="search-btn" @click="searchArticles">搜索</button>
        </div>
      </div>

      <!-- 文章列表 -->
      <div class="article-list">
        <div class="article-item" v-for="article in filteredArticles" :key="article.id" @click="openArticle(article.url)">
          <div class="article-meta">
            <span class="article-date">{{ article.date }}</span>
            <div class="article-tags">
              <span class="article-tag" v-for="tag in article.tags" :key="tag">{{ tag }}</span>
            </div>
          </div>
          <h2 class="article-title">{{ article.title }}</h2>
          <div class="article-summary">{{ article.summary }}</div>
          <div class="article-content-preview">{{ article.preview }}</div>
          <div class="article-footer">
            <span class="read-more">阅读全文 <i class="fas fa-arrow-right"></i></span>
            <span class="article-stats"><i class="fas fa-eye"></i> {{ article.views }}</span>
          </div>
        </div>
      </div>

      <!-- 分页 -->
      <div class="pagination">
        <span class="page-btn" @click="changePage(currentPage - 1)"><i class="fas fa-chevron-left"></i></span>
        <span class="page-btn" v-for="p in totalPages" :key="p" :class="{ active: currentPage === p }" @click="changePage(p)">{{ p }}</span>
        <span class="page-btn next" @click="changePage(currentPage + 1)">下一页 <i class="fas fa-chevron-right"></i></span>
      </div>

      <!-- 推荐文章侧栏 -->
      <div class="sidebar">
        <h3 class="sidebar-title">热门推荐</h3>
        <ul class="recommend-list">
          <li class="recommend-item" @click="openArticle('https://mp.weixin.qq.com/s/KUY7dO6d9_NaYGDME0Ni4w')">• McKinsey-企业数字化转型内涵，路径，评估及案例</li>
          <li class="recommend-item" @click="openArticle('https://zhuanlan.zhihu.com/p/2005345772112222112')">• IBM 2026新观点：什么是首席数据官（CDO）？</li>
          <li class="recommend-item" @click="openArticle('https://mp.weixin.qq.com/s/hEcPxR4F7gIIW2B_jxErxQ')">• [咨询] 石油化工行业数字化转型</li>
          <li class="recommend-item" @click="openArticle('https://mp.weixin.qq.com/s/cbeBvzHlcFQxMwFiRg4uQw')">• [艾森哲-2026]十五五数字化转型规划</li>
          <li class="recommend-item" @click="openArticle('https://mp.weixin.qq.com/s/6wtxU2-Bzo_JCAB9kNNO5g')">• IBM集团企业数字化转型解决方案</li>
        </ul>
      </div>
    </div>

    <!-- 底部转化模块 -->
    <section id="contact">
      <div class="container">
        <div class="cta-section">
          <div class="cta-title">获取更多数字化转型深度内容</div>
          <p style="font-size: 18px; margin-bottom: 30px;">订阅我们的邮件，每周获取最新数字化转型实践文章与行业报告</p>
          <button class="btn-primary" @click="showSubscribeModal = true">立即订阅</button>
        </div>
      </div>
    </section>

    <!-- 订阅弹窗 -->
    <div class="modal-overlay" v-if="showSubscribeModal" @click.self="showSubscribeModal = false">
      <div class="modal-container">
        <span class="modal-close" @click="showSubscribeModal = false">&times;</span>
        <h3 style="margin-bottom: 20px;">订阅数字化转型专题</h3>
        <form @submit.prevent="submitSubscribe">
          <div style="margin-bottom: 15px;">
            <input type="text" placeholder="姓名" style="width:100%; padding:12px; border-radius:8px; border:1px solid #ddd;">
          </div>
          <div style="margin-bottom: 15px;">
            <input type="email" placeholder="企业邮箱 *" style="width:100%; padding:12px; border-radius:8px; border:1px solid #ddd;">
          </div>
          <div style="margin-bottom: 15px;">
            <input type="text" placeholder="公司名称" style="width:100%; padding:12px; border-radius:8px; border:1px solid #ddd;">
          </div>
          <button class="btn-primary" style="width:100%;">确认订阅</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DigitalTransformationArticles',
  data() {
    return {
      activeCategory: 'all',
      searchKeyword: '',
      searchActive: false,
      currentPage: 1,
      showSubscribeModal: false,
      articles: [
        {
          id: 1, category: 'strategy', date: '2024-09-19',
          tags: ['McKinsey', '战略框架', '转型路径'],
          title: 'McKinsey-企业数字化转型内涵，路径，评估及案例',
          summary: '深度解析数字化转型的本质内涵、实施路径与成熟度评估模型，结合全球领先企业案例，为企业转型提供系统方法论。',
          preview: '文章汇总麦肯锡关于数字化转型的核心观点，涵盖转型内涵（技术+战略+组织）、实施路径（从试点到规模化）、评估框架（成熟度四阶段）及多个行业标杆案例。为企业制定数字化转型战略提供国际视野的参考框架。',
          views: '2.8k阅读',
          url: 'https://mp.weixin.qq.com/s/KUY7dO6d9_NaYGDME0Ni4w'
        },
        {
          id: 2, category: 'industry', date: '2025-05-18',
          tags: ['锂电池', '数据管理', '行业方案'],
          title: '锂电池数字化转型与数据管理规划',
          summary: '聚焦锂电池制造全流程，提出从研发、生产到回收的数据管理规划，构建端到端数据治理体系，提升产品良率与运营效率。',
          preview: '针对锂电池行业特点，规划涵盖电芯设计数据、生产过程参数、质量检测数据、设备运行数据等全生命周期管理。提出"数据资产化-资产服务化-服务业务化"的演进路径，通过数据平台实现配方优化、工艺改进、预测性维护。',
          views: '1.9k阅读',
          url: 'https://mp.weixin.qq.com/s/uIcsrUq0NSfzSu94nQUzsQ'
        },
        {
          id: 3, category: 'strategy', date: '2025-12-22',
          tags: ['艾森哲', '十五五', '战略规划'],
          title: '[艾森哲-2026]十五五数字化转型规划',
          summary: '面向"十五五"时期的企业战略规划，提出现状分析、蓝图规划、实施路线、数字化业务试点的完整方法论，细分产业特征与典型产品分析。',
          preview: '规划方法论涵盖现状分析、蓝图规划、实施路线、数字化业务试点四大阶段。聚焦OTD（订单到交付）、IPD（产品开发流）等核心流程，以投入紧迫、收益明确的数字化场景项目为切入点，推动企业数字化转型落地。',
          views: '2.3k阅读',
          url: 'https://mp.weixin.qq.com/s/cbeBvzHlcFQxMwFiRg4uQw'
        },
        {
          id: 4, category: 'strategy', date: '2025-11-07',
          tags: ['IBM', '集团方案', '实战攻略'],
          title: 'IBM集团企业数字化转型解决方案：破局之路与实战攻略',
          summary: '针对大型集团企业，提出从战略到落地的数字化转型整体解决方案，涵盖组织、流程、技术、数据四大核心要素。',
          preview: '基于IBM服务全球大型企业经验，提出"平台化+敏捷化"转型模式。从集团管控、业务协同、数据治理三个层面设计转型蓝图。强调以数据中台打通业务壁垒，以AI赋能决策优化，分享能源、制造等行业案例。',
          views: '2.1k阅读',
          url: 'https://mp.weixin.qq.com/s/6wtxU2-Bzo_JCAB9kNNO5g'
        },
        {
          id: 5, category: 'industry', date: '2025-12-11',
          tags: ['石油化工', 'TVCO', '智能工厂'],
          title: '[咨询] 石油化工行业数字化转型',
          summary: '深度剖析石化行业痛点，提出端到端运营拉通、全价值链优化(TVCO)、智能工厂建设等转型路径与实践案例。',
          preview: '针对石化行业信息孤岛、计划与执行脱节等问题，提出"点-线-面"转型框架：点（关键参数优化，如氧含量）、线（产供销协同平台）、面（全价值链优化）。详述TVCO方法论，通过需求预测、生产排产、定价优化等工具提升毛利。构建智能工厂"三圈联动"模式，实现设备预测、能效优化、安全预警。',
          views: '2.5k阅读',
          url: 'https://mp.weixin.qq.com/s/hEcPxR4F7gIIW2B_jxErxQ'
        },
        {
          id: 6, category: 'itplan', date: '2025-07-18',
          tags: ['IT规划', '企业架构', '实施路径'],
          title: '数字化转型及IT规划',
          summary: '从企业架构(EA)视角，系统阐述如何制定与企业战略对齐的数字化转型规划与IT实施路线图。',
          preview: '采用"业务架构-数据架构-应用架构-技术架构"四层规划方法，确保IT战略与业务战略对齐。提出数字化转型规划五步法：战略解读、现状评估、蓝图设计、实施路径、治理保障。强调通过能力规划、项目群管理、投资回报评估确保规划落地。',
          views: '1.7k阅读',
          url: 'https://mp.weixin.qq.com/s/Z7TNwr9rjXHk9ahsCNn6Jg'
        },
        {
          id: 7, category: 'cdo', date: '2026-02-12',
          tags: ['IBM', '首席数据官', 'CDO vs CIO'],
          title: '数字文化素养|IBM 2026年新观点：什么是首席数据官（CDO）？与CIO 差异是什么',
          summary: '基于IBM 2026年最新研究，全面解析首席数据官(CDO)的职责定位、价值贡献，以及与CIO的核心差异，展望CDO未来演进方向。',
          preview: 'CDO负责数据治理、数据安全、数据生命周期管理、数据分析、数据战略五大核心职责。与CIO的区别在于：CIO负责技术基础设施，CDO负责利用数据创造业务价值。未来CDO可能演变为首席数据、分析和AI官(CDAIO)。表现出色的CDO直接向CEO汇报，其数据战略聚焦于从数据到业务价值的视线、加速业务增长、模式创新和生态合作。',
          views: '3.2k阅读',
          url: 'https://zhuanlan.zhihu.com/p/2005345772112222112'
        },
        {
          id: 8, category: 'cdo', date: '2026-01-27',
          tags: ['古杉数据', 'CDO实践班', '公开课'],
          title: '北京古杉数据联合多机构成功举办 2026 首席数据官 CDO（实践班）公开课（BJ）',
          summary: '2026年1月，北京古杉数据联合工信部电子技术标准研究院等机构成功举办首席数据官CDO实践班公开课，聚焦数据管理体系、资产化实战、AI落地与合规出境。',
          preview: '课程涵盖五大模块：体系构建（数据管理框架）、资产化实战（确权、定价、入表）、AI与模型落地（技术选型、风险控制）、合规与出境（跨境流动安全）、实战导向案例。活动汇聚30余位企业CDO、数字化负责人，通过政策解读、案例剖析与圆桌研讨，为数据资产化与智能化转型提供全景式解决方案。',
          views: '1.5k阅读',
          url: 'https://zhuanlan.zhihu.com/p/1999542732037828665'
        }
      ]
    }
  },
  computed: {
    filteredArticles() {
      let list = this.articles
      if (this.activeCategory !== 'all') {
        list = list.filter(a => a.category === this.activeCategory)
      }
      if (this.searchActive && this.searchKeyword) {
        const kw = this.searchKeyword.toLowerCase()
        list = list.filter(a =>
          a.title.toLowerCase().includes(kw) ||
          a.summary.toLowerCase().includes(kw) ||
          a.preview.toLowerCase().includes(kw)
        )
      }
      return list
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.filteredArticles.length / 6)) || 1
    }
  },
  methods: {
    searchArticles() {
      this.searchActive = true
    },
    changePage(p) {
      if (p >= 1 && p <= this.totalPages) {
        this.currentPage = p
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    },
    openArticle(url) {
      window.open(url, '_blank')
    },
    submitSubscribe() {
      alert('订阅成功！')
      this.showSubscribeModal = false
    }
  },
  watch: {
    activeCategory() {
      this.currentPage = 1
    },
    searchKeyword(val) {
      if (!val) this.searchActive = false
    }
  }
}
</script>

<style scoped>
.dt-articles-page {
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  background-color: #ffffff;
  color: #2B2F3A;
  line-height: 1.6;
  --primary-blue: #1F3F8F;
  --deep-indigo: #0E1F52;
  --light-porcelain: #EAF0FB;
  --bg-light: #f5f7fa;
  --text-dark: #2B2F3A;
  --card-shadow: 0 12px 28px rgba(0,10,30,0.04), 0 4px 16px rgba(31,63,143,0.08);
  --border-light: #e9edf4;
  --nav-height: 60px;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
}

/* 面包屑 */
.breadcrumb-nav {
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px 24px;
  font-size: 14px;
  color: #5f6a7d;
}
.breadcrumb-nav a {
  color: #1F3F8F;
  text-decoration: none;
}
.breadcrumb-nav a:hover {
  text-decoration: underline;
}
.breadcrumb-nav .separator {
  margin: 0 8px;
  color: #ccc;
}
.breadcrumb-nav .current {
  color: #2B2F3A;
}

/* 页面标题 */
.page-header {
  margin-bottom: 40px;
  margin-top: 20px;
}
.page-title {
  font-size: 38px;
  font-weight: 700;
  color: var(--deep-indigo);
  margin-bottom: 16px;
}
.page-desc {
  font-size: 18px;
  color: #5f6a7d;
  max-width: 800px;
}

/* 筛选栏 */
.filter-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
  flex-wrap: wrap;
  gap: 20px;
}
.filter-tabs {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.filter-tab {
  padding: 8px 24px;
  border-radius: 40px;
  background: white;
  border: 1px solid var(--border-light);
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
}
.filter-tab.active, .filter-tab:hover {
  background: var(--primary-blue);
  color: white;
  border-color: var(--primary-blue);
}
.search-box {
  display: flex;
  gap: 8px;
}
.search-input {
  padding: 10px 16px;
  border-radius: 40px;
  border: 1px solid var(--border-light);
  width: 250px;
  font-size: 14px;
}
.search-btn {
  padding: 10px 24px;
  border-radius: 40px;
  background: var(--primary-blue);
  color: white;
  border: none;
  cursor: pointer;
  transition: 0.3s;
}
.search-btn:hover {
  background: #0e3170;
}

/* 文章列表 */
.article-list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 30px;
  margin-bottom: 50px;
}
.article-item {
  background: white;
  border-radius: 16px;
  padding: 32px;
  box-shadow: var(--card-shadow);
  transition: all 0.3s;
  cursor: pointer;
  border: 1px solid rgba(31,63,143,0.05);
}
.article-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 24px 40px rgba(31,63,143,0.12);
}
.article-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;
}
.article-date {
  color: #5f6a7d;
  font-size: 14px;
  background: var(--bg-light);
  padding: 4px 12px;
  border-radius: 40px;
}
.article-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.article-tag {
  background: var(--light-porcelain);
  padding: 4px 12px;
  border-radius: 40px;
  font-size: 12px;
  color: var(--primary-blue);
}
.article-title {
  font-size: 24px;
  font-weight: 600;
  color: var(--deep-indigo);
  margin-bottom: 12px;
  line-height: 1.4;
}
.article-summary {
  color: #5f6a7d;
  margin-bottom: 20px;
  line-height: 1.7;
  border-left: 3px solid var(--light-porcelain);
  padding-left: 20px;
}
.article-content-preview {
  color: var(--text-dark);
  margin-bottom: 20px;
  font-size: 15px;
  line-height: 1.7;
  background: #fafbfc;
  padding: 20px;
  border-radius: 12px;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid var(--border-light);
}
.article-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.read-more {
  color: var(--primary-blue);
  text-decoration: none;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: gap 0.3s;
}
.article-item:hover .read-more {
  gap: 12px;
}
.article-stats {
  font-size: 14px;
  color: #8a95a8;
}

/* 分页 */
.pagination {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin: 60px 0;
}
.page-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border: 1px solid var(--border-light);
  cursor: pointer;
  transition: all 0.3s;
}
.page-btn:hover, .page-btn.active {
  background: var(--primary-blue);
  color: white;
  border-color: var(--primary-blue);
}
.page-btn.next {
  width: auto;
  padding: 0 16px;
  border-radius: 40px;
}

/* 推荐文章侧栏 */
.sidebar {
  background: var(--bg-light);
  border-radius: 16px;
  padding: 24px;
  margin-top: 40px;
}
.sidebar-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  color: var(--deep-indigo);
}
.recommend-list {
  list-style: none;
  padding: 0;
}
.recommend-item {
  padding: 12px 0;
  border-bottom: 1px solid var(--border-light);
  cursor: pointer;
  transition: color 0.3s;
}
.recommend-item:hover {
  color: var(--primary-blue);
}

/* 底部转化 */
.cta-section {
  background: var(--deep-indigo);
  border-radius: 32px;
  padding: 60px;
  color: white;
  text-align: center;
  margin: 60px 0;
}
.cta-title {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 16px;
}
.btn-primary {
  display: inline-block;
  background: var(--primary-blue);
  color: white;
  border: none;
  padding: 14px 36px;
  border-radius: 60px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s;
  text-decoration: none;
  font-size: 16px;
}
.btn-primary:hover {
  background: #0e3170;
  transform: translateY(-2px);
}

/* 弹窗 */
.modal-overlay {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(11,26,51,0.6);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-container {
  background: white;
  border-radius: 32px;
  padding: 40px;
  max-width: 500px;
  width: 90%;
}
.modal-close {
  float: right;
  font-size: 24px;
  cursor: pointer;
}

@media (max-width: 768px) {
  .filter-bar {
    flex-direction: column;
    align-items: stretch;
  }
  .search-box {
    width: 100%;
  }
  .search-input {
    width: 100%;
  }
  .page-title {
    font-size: 28px;
  }
}
</style>
